module.exports = class IntercomTransformer {
  constructor(contact) {
    this.contact = contact
  }

  transform() {
    const email = this.contact.email || ""
    const classification =
      email.length > 0 || this.contact.last_replied_at ? "Lead" : "Visitor"

    return {
      classification,
      email,
      identifier: email.length > 0 ? email : this.contact.id,
      name: this.contact.name,
      createdAt:
        typeof this.contact.created_at == "string"
          ? new Date(this.contact.created_at)
          : new Date(this.contact.created_at * 1000),
    }
  }
}
